import { render, staticRenderFns } from "./acceptedVisits.vue?vue&type=template&id=3cf0917a"
import script from "./acceptedVisits.vue?vue&type=script&lang=js"
export * from "./acceptedVisits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports